import React from "react";
import { useNavigate } from "react-router-dom";
import { DocumentCardProps } from "./DocumentCard.types";
import { CardContainer, DocumentTitle, IconsWrapper } from "./DocumentCard.styles";
import StatusBadge from "../StatusBadge/StatusBadge";

const DocumentCard: React.FC<DocumentCardProps> = ({
  title,
  isSubscribed,
  onClick,
}) => {
  return (
    <CardContainer onClick={onClick}>
      <IconsWrapper>
        <StatusBadge
          text={isSubscribed ? "Подписан" : "Не подписан"}
          variant={isSubscribed ? "green" : "red"}
        />
      </IconsWrapper>
      <DocumentTitle>{title}</DocumentTitle>
    </CardContainer>
  );
};

export default DocumentCard;
